$(function () {
  getIp();
  setupCID();

  const isStaging =
    window.location.href.indexOf("nihlo-cosmetics-dev.myshopify.com") > -1;
  const baseUrl = isStaging
    ? "https://qa.apps.nihlo.com.co/"
    : "https://apps.nihlo.com.co/";
  const apiKey = "Api-Key 2WraagS5.pf9Fzsl9HCXc9GdCAtq4KgXi6Htgaf1i";

  $(document).on("click", "#send_newsletter", function (e) {
    if (
      validateRequiredFields("#newsletter_form") &&
      validateEmail("#newsletter_email") &&
      validateCedula("#newsletter_cedula")
    ) {
      const email = $("#newsletter_email").val();
      const cedula = $("#newsletter_cedula").val();
      const endpoint = `${baseUrl}api/client/habeas_data/`;
      const data = {
        id_type: "C.C",
        email: email,
        id_number: cedula,
        ip: window.ip,
        habeas_data: true,
        request_type: "SUBSCRIBE",
      };

      // Limpio el formulario
      $("#newsletter_email").val("");
      $("#newsletter_cedula").val("");
      $("#checkout_accept_terms").prop("checked", false);

      $.ajax({
        url: endpoint,
        type: "POST",
        data: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: apiKey,
        },
        success: function (response) {
          Swal.fire({
            icon: "success",
            text: "Se ha registrado correctamente",
          });
        },
        error: function (error) {
          Swal.fire({
            icon: "error",
            text: "Ha ocurrido un error en el registro",
          });
        },
      });
    }
  });

  $(document).on("click", "#register_btn", function (e) {
    console.log("register_btn");

    if (validateRequiredFields("#create_customer") && validateEmail("#Email")) {
      let firstName = $("#FirstName").val();
      let lastName = $("#LastName").val();
      let email = $("#Email").val();
      let password = $("#CreatePassword").val();

      let data = {
        first_name: firstName,
        last_name: lastName,
        email: email,
        ip: window.ip,
        habeas_data: true,
        request_type: "REGISTER",
      };

      console.log(data);

      const endpoint = `${baseUrl}api/client/habeas_data/`;

      $.ajax({
        url: endpoint,
        type: "POST",
        data: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: apiKey,
        },
        success: function (response) {
          $("#create_customer").submit();
        },
        error: function (error) {
          Swal.fire({
            icon: "error",
            text: "Ha ocurrido un error en el registro",
          });
        },
      });
    }
  });

  $(document).on("click", "#send_newsletter_popup", function (e) {
    if (
      validateRequiredFields("#newsletter_form_popUp") &&
      validateName("#newsletter_fullName") &&
      validateCellPhone("#newsletter_cellPhone") &&
      validateEmail("#newsletter_email") &&
      validateCedula("#newsletter_cedula")
    ) {
      const fullName = $("#newsletter_fullName").val();
      const cellphone = $("#newsletter_cellPhone").val();
      const email = $("#newsletter_email").val();
      const cedula = $("#newsletter_cedula").val();

      const endpoint = `${baseUrl}api/client/habeas_data/`;

      let data = {};
      // Validar si el campo de teléfono tiene algún valor
      if (!cellphone) {
        data = {
          id_type: "C.C",
          name: fullName,
          email: email,
          id_number: cedula,
          ip: window.ip,
          habeas_data: true,
          request_type: "SUBSCRIBE",
        };
      } else {
        data = {
          id_type: "C.C",
          name: fullName,
          phone: cellphone,
          email: email,
          id_number: cedula,
          ip: window.ip,
          habeas_data: true,
          request_type: "SUBSCRIBE",
        };
      }

      $.ajax({
        url: endpoint,
        type: "POST",
        data: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: apiKey,
        },
        success: function (response) {
          Swal.fire({
            icon: "success",
            text: "Se ha registrado correctamente",
          });
        },
        error: function (error) {
          Swal.fire({
            icon: "error",
            text: "Ha ocurrido un error en el registro",
          });
        },
      });
    }
  });

  $(document).on("change", ".checkRegister", function () {
    console.log("checkRegister");
    if (this.checked) {
      // $(this).closest("form").find("#register_btn").prop("disabled", false);
    } else {
      $(this).closest("form").find("#register_btn").prop("disabled", true);
    }
  });

  $(document).on("change", ".checkout_accept_terms", function () {
    if (this.checked) {
      // $(this).closest("form").find(".send_button").prop("disabled", false);
    } else {
      $(this).closest("form").find(".send_button").prop("disabled", true);
    }
  });

  // Ajuste customDev
  function validateAddressFields() {
    const ids = ['address_line1', 'address_dpto', 'address_city'];
    let allOk = true;
    ids.forEach(function (id) {
      const el = document.getElementById(id);
      if (!el) return;
      const wrapper = el.closest('.float-field');
      if (!wrapper) return;
      if (el.value.trim() === '') {
        wrapper.classList.add('field-error');
        allOk = false;
      } else {
        wrapper.classList.remove('field-error');
      }
    });
    return allOk;
  }

  function clearAddressFieldErrors() {
    ['address_line1', 'address_dpto', 'address_city'].forEach(function (id) {
      const el = document.getElementById(id);
      if (!el) return;
      const wrapper = el.closest('.float-field');
      if (wrapper) wrapper.classList.remove('field-error');
    });
    const errMsg = document.getElementById('cartTearmError');
    if (errMsg) errMsg.style.display = 'none';
  }

  $(document).on("change", "#cartTearm", function () {
    console.log("cartTearm");
    // Capturo el boton para ir al CheckOut
    //let buttonGoToCheckout = captureInputGoToCheckout();
    let buttonGoToCheckout = "#cartCheckout";

    // Si el input esta "checked"
    if (this.checked) {
      // Valido que el documento cumpla con las reglas
      let isValid = validateDocument();

      if (isValid) {
        // Si el formulario de dirección está activo, verificar que esté completo
        if (typeof window.nihloAddressReady === 'function') {
          const addrOk = validateAddressFields();
          const errMsg = document.getElementById('cartTearmError');
          if (!addrOk) {
            if (errMsg) errMsg.style.display = 'block';
            $(buttonGoToCheckout).prop("disabled", true);
          } else {
            if (errMsg) errMsg.style.display = 'none';
            $(buttonGoToCheckout).prop("disabled", false); // Habilito el boton
          }
        } else {
          $(buttonGoToCheckout).prop("disabled", false); // Habilito el boton
        }
      } else {
        $(buttonGoToCheckout).prop("disabled", true); // Deshabilito el boton
        $("#cartTearm").prop("checked", false); // Cambio el CheckBox (Terminos y condiciones)
      }
    } else {
      $(buttonGoToCheckout).prop("disabled", true); // Deshabilito el boton
      clearAddressFieldErrors();
    }
  });

  $(document).on("click", "#send_contact", function (e) {
    console.log("send_contact");
    if (validateRequiredFields("#contact_form")) {
      const email = $("#contact_email").val();
      const firstName = $("#contact_first_name").val();
      const lastName = $("#contact_last_name").val();
      const cellphone = $("#contact_cellphone").val();
      let phone = $("#contact_phone").val();
      const cedula = $("#contact_cedula").val();
      const city = $("#contact_city").val();
      const tema = $("#contact_temas").val();
      const tienda = $("#contact_tiendas").val();
      const message = $("#contact_message").val();

      if (phone.length == 0) {
        phone = "0000000";
      }

      const data = {
        id_type: "C.C",
        email: email,
        first_name: firstName,
        last_name: lastName,
        phone_number: cellphone,
        phone: phone,
        id_number: cedula,
        habeas_data: true,
        city_code: city,
        reason: tema,
        shop: tienda,
        coments: message,
        ip: window.ip,
      };

      console.log(data);

      const endpoint = `${baseUrl}api/client/contact_us/`;

      $.ajax({
        url: endpoint,
        type: "POST",
        data: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: apiKey,
        },
        success: function (response) {
          console.log("response");
          console.log(response);
          Swal.fire({
            icon: "success",
            text: "Su solicitud ha sido recibida de forma exitosa; próximamente le estaremos enviando a su correo electrónico el número de radicado y demás información.",
            confirmButtonText: "ACEPTAR",
          });
        },
        error: function (error) {
          console.log("error");
          console.log(error);
          Swal.fire({
            icon: "error",
            text: "Ha ocurrido un error en el envio de su solicitud",
            confirmButtonText: "ACEPTAR",
          });
        },
      });
    }
  });

  $(document).on("focusout", "#docnum", function (event) {
    // Verificar si el clic no ocurrió dentro del input
    if (!$(event.relatedTarget).is("#docnum")) {
      // Valido que el documento cumpla con las reglas
      let isValid = validateDocument();

      // Capturo el boton para ir al CheckOut
      let buttonGoToCheckout = captureInputGoToCheckout();

      if (!isValid) {
        $(buttonGoToCheckout).prop("disabled", true); // Deshabilito el boton
        $("#cartTearm").prop("checked", false); // Cambio el CheckBox (Terminos y condiciones)
      }
    }
  });
});

function getIp() {
  $.getJSON("https://api.ipify.org?format=json", function (e) {
    window.ip = e.ip;
  });
}

function setupCID() {
  try {
    if (document.cookie.indexOf("_ga=") > -1) {
      gaCookie = document.cookie.split("_ga=")[1].split(";")[0].split(".");
      clientID = gaCookie[2] + "." + gaCookie[3];
      $("#cid").val(clientID);
    }
  } catch (e) {
    console.log("Error al obtener la cookie de GA");
  }
}

function validateName(fullNameEl) {
  const fullName = $(fullNameEl).val();
  const errorMessage = $(fullNameEl).attr("data-required-msg");
  const nameRegex = /^[A-Za-z\s]+$/;

  if (nameRegex.test(fullName)) {
    $(fullNameEl).next(".invalid-feedback").remove();
    return true;
  } else {
    $(fullNameEl).after(`<div class="invalid-feedback">${errorMessage}</div>`);
    return false;
  }
}

function validateCellPhone(cellphoneEl) {
  const cellphone = $(cellphoneEl).val();
  const errorMessage = $(cellphoneEl).attr("data-required-msg");
  // Expresión regular que permite números, paréntesis, espacios, guiones y signo más
  // const phoneRegex = /^[0-9()+\s-]+$/;
  // Expresión regular que permite solo números
  const phoneRegex = /^[0-9]+$/;

  // Validar si el campo de teléfono tiene algún valor
  if (!cellphone) {
    return true;
  }

  if (phoneRegex.test(cellphone)) {
    $(cellphoneEl).next(".invalid-feedback").remove();
    return true;
  } else {
    $(cellphoneEl).after(`<div class="invalid-feedback">${errorMessage}</div>`);
    return false;
  }
}

function validateEmail(emailEl) {
  const email = $(emailEl).val();
  const errorMessage = $(emailEl).attr("data-required-msg");
  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

  if (emailRegex.test(email)) {
    $(emailEl).next(".invalid-feedback").remove();
    return true;
  } else {
    $(emailEl).after(`<div class="invalid-feedback">${errorMessage}</div>`);
    return false;
  }
}

function validateCedula(cedulaEl) {
  // validar si la longitud de la cedula esta entre 4 y 10 y es diferente de 9
  const cedulaLength = $(cedulaEl).val().length;
  const errorMessage = $(cedulaEl).attr("data-required-msg");

  if (cedulaLength < 4 || cedulaLength > 10 || cedulaLength == 9) {
    $(cedulaEl).after(`<div class="invalid-feedback">${errorMessage}</div>`);
    return false;
  } else {
    $(cedulaEl).next(".invalid-feedback").remove();
    return true;
  }
}

function validateRequiredFields(formEl) {
  let valid = true;

  $(`${formEl} .invalid-feedback`).remove();

  $(`${formEl} .required`).each(function () {
    const errorMessage = $(this).attr("data-required-msg");
    if ($(this).val() == "") {
      valid = false;
      $(this).addClass("is-invalid");
      $(this).after(`<div class="invalid-feedback">${errorMessage}</div>`);
    } else {
      $(this).removeClass("is-invalid");
    }
  });
  return valid;
}

function validateDocument() {
  let documentType = $("#custom_docs_ship").val(); // Tipo de documento
  let number = $("#docnum").val(); // Numero de documento
  let valid = false; // Estado del input
  let conditions = {}; // Condiciones a evaluar
  let invalidCondition = ""; // Captura de validacion que no se cumplio
  let message = ""; // Mensaje de error

  // Si el campo no esta vacio
  if (number != "") {
    switch (documentType) {
      // C - Cedula de Ciudadanía
      case "C":
        conditions = [
          // - No debe permitir ingresar letras
          { condition: onlyNumbers(number), message: "Solo números" },
          // - El documento tiene un mínimo de 4 dígitos hasta máximo 10 dígitos, no acepta documentos de 9 dígitos
          {
            condition: number.length >= 4 && number.length <= 8,
            message: "Mínimo de 4 dígitos hasta máximo 10 dígitos",
          },
          // - No permite iniciar con ceros
          {
            condition: number.charAt(0) !== "0",
            message: "El primer dígito no puede ser '0'",
          },
        ];

        invalidCondition = conditions.find((item) => !item.condition);

        if (invalidCondition) {
          // Si al menos una condición falla
          message = invalidCondition.message;
        } else {
          // Si todas las condiciones son verdaderas
          valid = true;
        }

        if (!valid) {
          conditions = [
            // - No debe permitir ingresar letras
            { condition: onlyNumbers(number), message: "Solo números" },
            // - El documento tiene un mínimo de 4 dígitos hasta máximo 10 dígitos, no acepta documentos de 9 dígitos
            {
              condition: number.length === 10,
              message: "Mínimo de 4 dígitos hasta máximo 10 dígitos",
            },
            // - No permite iniciar con ceros
            {
              condition: number.charAt(0) !== "0",
              message: "El primer dígito no puede ser '0'",
            },
            // - Cuando el documento sea de 10 dígitos no debe permitir crear documentos que inicien por 6,7,8 y 9
            {
              condition: !["6", "7", "8", "9"].includes(number.charAt(0)),
              message: "El primer dígito no puede ser '6', '7', '8' o '9'",
            },
          ];

          invalidCondition = conditions.find((item) => !item.condition);

          if (invalidCondition) {
            // Si al menos una condición falla
            message = invalidCondition.message;
          } else {
            // Si todas las condiciones son verdaderas
            valid = true;
          }
        }
        break;
      // D - Documento Extranjero
      case "D":
        conditions = [
          // - Largo está en las cantidades de 7,8,9,10,11,12,13,14,15 y 16 dígitos.
          {
            condition: number.length >= 7 && number.length <= 16,
            message: "La longitud debe estar entre 7 y 16 caracteres",
          },
          // - Permite ingresar letras y números
          {
            condition: onlyLettersAndNumbers(number),
            message: "Solo se permiten letras y números",
          },
        ];

        invalidCondition = conditions.find((item) => !item.condition);

        if (invalidCondition) {
          // Si al menos una condición falla
          message = invalidCondition.message;
        } else {
          // Si todas las condiciones son verdaderas
          valid = true;
        }
        break;
      // W - Rut Personas Naturales Inv. Extranjero
      case "W":
        conditions = [
          // - Su largo está en las cantidades 10 dígitos incluyendo DV
          {
            condition: number.length === 10,
            message: "La longitud debe ser 10 caracteres",
          },
          // - No debe permitir ingresar
          {
            condition: onlyNumbers(number),
            message: "Solo se permiten números",
          },
          // - Comienzan por 6 ó 7 únicamente, no permite iniciar con ceros
          {
            condition: ["6", "7"].includes(number.charAt(0)),
            message: "El primer dígito debe ser 6 o 7",
          },
        ];

        invalidCondition = conditions.find((item) => !item.condition);

        if (invalidCondition) {
          // Si al menos una condición falla
          message = invalidCondition.message;
        } else {
          // Si todas las condiciones son verdaderas
          valid = true;
        }
        break;
      // E - Cedula de Extranjería
      case "E":
        conditions = [
          // - Su largo está en la longitud de 5,6,7 dígitos.
          {
            condition: number.length >= 5 && number.length <= 7,
            message: "La longitud debe estar entre 5 y 7 caracteres",
          },
          // - No permite iniciar con ceros
          {
            condition: number.charAt(0) !== "0",
            message: "El primer dígito no puede ser 0",
          },
          // - No permite ingresar letras
          {
            condition: onlyNumbers(number),
            message: "Solo se permiten números",
          },
        ];

        invalidCondition = conditions.find((item) => !item.condition);

        if (invalidCondition) {
          // Si al menos una condición falla
          message = invalidCondition.message;
        } else {
          // Si todas las condiciones son verdaderas
          valid = true;
        }
        break;
        
      // R - Registro Único Tributario
      case "R":
        conditions = [
          // - largo de 5-9 ó 11-12 dígitos
          {
            condition:
              (number.length >= 5 && number.length <= 9) ||
              (number.length >= 11 && number.length <= 12),
            message:
              "La longitud debe estar entre 5 y 9 o entre 11 y 12 caracteres",
          },
          // - No permite iniciar con ceros
          {
            condition: number.charAt(0) !== "0",
            message: "El primer dígito no puede ser 0",
          },
          // - No debe permitir ingresar letras
          {
            condition: onlyNumbers(number),
            message: "Solo se permiten números",
          },
        ];

        invalidCondition = conditions.find((item) => !item.condition);

        if (invalidCondition) {
          // Si al menos una condición falla
          message = invalidCondition.message;
        } else {
          // Si todas las condiciones son verdaderas
          valid = true;
        }
        break;
      // N - Número de Identificación Tributaria
      case "N":
        conditions = [
          // - Largo de 9 dígitos más el digito de verificación dando un total de 10 dígitos.
          {
            condition: number.length === 10,
            message: "La longitud debe ser de 10 caracteres",
          },
          // - Iniciar por 8 o 9 únicamente
          {
            condition: number.charAt(0) === "9" || number.charAt(0) === "8",
            message: "El primer dígito debe ser 8 o 9",
          },
          // - No debe permitir ingresar letras en el número de documento
          {
            condition: onlyNumbers(number),
            message: "Solo se permiten números",
          },
        ];

        invalidCondition = conditions.find((item) => !item.condition);

        if (invalidCondition) {
          // Si al menos una condición falla
          message = invalidCondition.message;
        } else {
          // Si todas las condiciones son verdaderas
          valid = true;
        }
        break;
      // P - Pasaporte
      case "P":
        conditions = [
          // - Longitud de 6 hasta 16 dígitos, permite iniciar con ceros, permite caracteres alfanuméricos y caracteres especiales.
          {
            condition: number.length >= 6 && number.length <= 16,
            message: "La longitud debe estar entre 6 y 16 caracteres",
          },
        ];

        invalidCondition = conditions.find((item) => !item.condition);

        if (invalidCondition) {
          // Si al menos una condición falla
          message = invalidCondition.message;
        } else {
          // Si todas las condiciones son verdaderas
          valid = true;
        }

        if (number.length >= 6 && number.length <= 16) {
          valid = true;
        }
        break;
      // U - NIUP
      case "U":
        conditions = [
          // - Longitud del documento debe ser de 10 dígitos
          {
            condition: number.length == 10,
            message: "La longitud debe ser de 10 caracteres",
          },
          // - No permite iniciar con ceros
          {
            condition: number.charAt(0) != "0",
            message: "El primer carácter no puede ser '0'",
          },
          // - No debe permitir ingresar letras
          {
            condition: onlyNumbers(number),
            message: "Solo se permiten números",
          },
        ];

        invalidCondition = conditions.find((item) => !item.condition);

        if (invalidCondition) {
          // Si al menos una condición falla
          message = invalidCondition.message;
        } else {
          // Si todas las condiciones son verdaderas
          valid = true;
        }
        break;
      // V - Permiso Especial de Permanencia
      case "V":
        conditions = [
          // - Longitud del documento debe ser de 15 dígitos
          {
            condition: number.length === 15,
            message: "La longitud debe ser de 15 caracteres",
          },
          // - No permite iniciar con ceros
          {
            condition: number.charAt(0) !== "0",
            message: "El primer carácter no puede ser '0'",
          },
          // - No debe permitir ingresar letras
          {
            condition: onlyNumbers(number),
            message: "Solo se permiten números",
          },
        ];

        invalidCondition = conditions.find((item) => !item.condition);

        if (invalidCondition) {
          // Si al menos una condición falla
          message = invalidCondition.message;
        } else {
          // Si todas las condiciones son verdaderas
          valid = true;
        }
        break;
    }
  } else {
    message = "Campo necesario";
  }

  if (valid) {
    $("#errorMessage").html("");
    $("#errorMessage").hide();
  } else {
    $("#errorMessage").html(`${message} *`); // Imprimo el mensaje
    $("#errorMessage").show(); // Visible el mensaje
  }

  return valid;
}

function onlyNumbers(text) {
  return /^[0-9]+$/.test(text);
}

function onlyLettersAndNumbers(text) {
  return /^[ÑA-Zña-z0-9]+$/.test(text);
}

// Save custom form cart attributes
class CartFormFactura extends HTMLElement {
  constructor() {
    super();

    this.customerData = null;
    this.formCart = document.getElementById("form_cart");
    this.documentInput = document.querySelector("[name='attributes[Numero de documento]']");
  }

  connectedCallback() {
    this.loadCustomerData();
    this.bindEvents();

    if (this.documentInput) {
      this.customerData.company = this.documentInput.value;
    }
  }

  bindEvents() {
    this.addEventListener("change", this.updateCartAttributes.bind(this));
    this.formCart.addEventListener("submit", this.handleFormSubmit.bind(this));
  }

  loadCustomerData() {
    const customerDataElement = document.getElementById(
      "cart-form-factura-customer-data"
    );

    if (customerDataElement) {
      try {
        this.customerData = JSON.parse(customerDataElement.textContent);
        // console.log(this.customerData);
      } catch (error) {
        console.error("Error parsing customer data:", error);
      }
    }
  }

  updateCustomerData(name, value) {
    if (name === "attributes[Numero de documento]") {
      console.log("Numero de documento", value);
      this.customerData.company = value;
    }
  }

  updateCartAttributes(e) {
    let formData = new FormData();
    formData.append(e.target.name, e.target.value);
    this.updateCustomerData(e.target.name, e.target.value);

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => console.log("updateCartAttributes", data));
  }

  async generarURLCheckout() {
    const datos = this.customerData || {};
    const params = new URLSearchParams();

    const addParam = (key, value) => {
      if (value && String(value).trim() !== "") {
        params.append(key, value);
      }
    };

    const addrVal = (id) => {
      const el = document.getElementById(id);
      return el && el.value.trim() ? el.value.trim() : null;
    };

    // spec: specs/enable-custom-form-address.md — FR-07 v3.0: company y phone no son
    // parámetros soportados por el cart permalink; el documento viaja como attributes[Numero de documento].
    addParam("checkout[email]", datos.email);
    addParam("checkout[shipping_address][first_name]", datos.first_name);
    addParam("checkout[shipping_address][last_name]", datos.last_name);
    const checkoutLine1Raw = addrVal("address_line1") || datos.address1 || '';
    const checkoutBarrio   = addrVal("address_barrio") || '';
    addParam("checkout[shipping_address][address1]", checkoutLine1Raw);
    // spec: specs/enable-custom-form-address.md — CA-49 resuelto: para sugerida/pre-validada se envía un espacio
    // para sobrescribir el [v:id] guardado en customer.address2 sin romper el parseo del checkout nuevo (que rechaza '').
    // ingresada → viaja el barrio (o se omite si está vacío).
    const tipoVal = document.getElementById('address_tipo')?.value || '';
    if (tipoVal === 'Sugerida' || !!window.nihloIsPreValidated) {
      params.append("checkout[shipping_address][address2]", ' ');
    } else {
      addParam("checkout[shipping_address][address2]", checkoutBarrio);
    }
    addParam("checkout[shipping_address][city]", addrVal("address_city") || datos.city);
    addParam("checkout[shipping_address][province]", addrVal("address_dpto") || datos.zone);
    addParam("checkout[shipping_address][country]", datos.country || "CO");
    addParam("checkout[shipping_address][zip]", addrVal("address_postal") || datos.postalCode);

    const fallbackUrl = `${window.Shopify.routes.root}checkout?${params.toString()}`;

    // spec: specs/enable-custom-form-address.md — FR-07 v3.0: el checkout nuevo (/checkouts/cn/) ignora
    // los params checkout[...] al entrar por /checkout?; solo el cart permalink los pre-llena (CA-60).
    try {
      const response = await fetch(window.Shopify.routes.root + "cart.js");
      const cart = await response.json();

      // CA-64: el permalink no soporta selling plans → flujo nativo sin prefill.
      const hasSellingPlan = cart.items.some((item) => item.selling_plan_allocation);
      if (!cart.items.length || hasSellingPlan) {
        return fallbackUrl;
      }

      // CA-62: el permalink crea un carrito nuevo — los atributos ya persistidos
      // (Direccion, Numero de documento, …) y la nota se re-envían como params.
      Object.entries(cart.attributes || {}).forEach(([key, value]) => {
        addParam(`attributes[${key}]`, value);
      });
      addParam("note", cart.note);

      const lines = cart.items
        .map((item) => `${item.variant_id}:${item.quantity}`)
        .join(",");
      return `${window.Shopify.routes.root}cart/${lines}?${params.toString()}`;
    } catch (error) {
      console.error("[nihlo] cart.js falló — fallback a /checkout:", error);
      return fallbackUrl;
    }
  }

  handleFormSubmit(e) {
    e.preventDefault();

    const initial = window.nihloAddrInitial || {};
    const currentLine1  = (document.getElementById('address_line1') || {}).value || '';
    const currentBarrio = (document.getElementById('address_barrio') || {}).value || '';
    const currentDpto   = (document.getElementById('address_dpto')   || {}).value || '';
    const currentCity   = (document.getElementById('address_city')   || {}).value || '';
    const addressUnchanged =
      currentLine1  === (initial.line1  || '') &&
      currentBarrio === (initial.barrio || '') &&
      currentDpto   === (initial.dpto   || '') &&
      currentCity   === (initial.city   || '');
    const canBypassAddressValidation = !!window.nihloIsPreValidated && addressUnchanged;
    if (canBypassAddressValidation) {
      this.generarURLCheckout().then((url) => {
        window.location.href = url;
      });
      return;
    }

    // spec: specs/enable-custom-form-address.md — FR-10: modo formulario-solo (enable_custom_form_address OFF).
    // Sin <address-suggestion-drawer> en el DOM no se consulta SITIDATA: checkout directo por URL.
    if (!document.querySelector("address-suggestion-drawer")) {
      this.generarURLCheckout().then((checkoutUrl) => {
        console.log("[nihlo] Modo formulario-solo — URL checkout:", checkoutUrl);
        window.location.href = checkoutUrl;
      });
      return;
    }

    const addressForm = document.querySelector("cart-form-address");
    if (addressForm) {
      const city = (document.getElementById("address_city") || {}).value || "";
      const line1 = (document.getElementById("address_line1") || {}).value || "";
      const address = line1;

      const url = addressForm.dataset.suggestionsUrl;

      const submitBtn = document.getElementById("cartCheckout");
      const originalValue = submitBtn ? submitBtn.value : null;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.value = "Procesando...";
        submitBtn.classList.add("is-loading");
      }

      const restoreBtn = function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.value = originalValue;
          submitBtn.classList.remove("is-loading");
        }
      };

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ city: city, address: address }),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          console.log("Address suggestions response:", data);
          restoreBtn();
          var drawer = document.querySelector("address-suggestion-drawer");
          if (drawer) {
            drawer._onConfirm = () => {
              // El flush persiste attributes[Direccion] ANTES de leer cart.js, para que el permalink lo re-envíe actualizado (CA-62).
              const flush = typeof window.nihloFlushTipo === 'function' ? window.nihloFlushTipo() : Promise.resolve();
              flush.catch(() => {})
                .then(() => this.generarURLCheckout())
                .then((url) => {
                  console.log("Redirecting to:", url);
                  window.location.href = url;
                });
            };
            drawer.open(data);
          }
        }.bind(this))
        .catch(function (err) {
          console.error("Address suggestions error:", err);
          restoreBtn();
          const drawer = document.querySelector("address-suggestion-drawer");
          if (drawer) {
            drawer._onConfirm = () => {
              const flush = typeof window.nihloFlushTipo === 'function' ? window.nihloFlushTipo() : Promise.resolve();
              flush.catch(() => {})
                .then(() => this.generarURLCheckout())
                .then((checkoutUrl) => {
                  window.location.href = checkoutUrl;
                });
            };
            drawer.open({ addresses: [] });
          }
        }.bind(this));

      return;
    }

    this.generarURLCheckout().then((url) => {
      window.location.href = url;
    });
  }
}

customElements.define("cart-form-factura", CartFormFactura);

class CartFormAddress extends HTMLElement {
  connectedCallback() {
    const tipoInput = document.getElementById("address_tipo");
    if (tipoInput) {
      const persistTipo = () => {
        const formData = new FormData();
        formData.append(tipoInput.name, tipoInput.value);
        return fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          body: formData,
        })
          .then((r) => r.json())
          .then((data) => console.log(data));
      };

      // Persists initial value on mount and on every change (e.g. Sugerida/Ingresada)
      tipoInput.addEventListener("change", persistTipo);
      persistTipo();
      window.nihloFlushTipo = persistTipo;
    }
  }

}

customElements.define("cart-form-address", CartFormAddress);
